import {
  createField,
  formStrings,
  newEmailField,
  newPasswordField,
  requiredStringField,
} from '@utils/forms';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export class AccountManagerForm {
  static instance: AccountManagerForm | undefined;

  static get shared() {
    if (AccountManagerForm.instance === undefined) {
      AccountManagerForm.instance = new AccountManagerForm();
    }
    return AccountManagerForm.instance;
  }

  displayName = createField((label) => requiredStringField(label, 1, 128), 'displayName', {
    ja: '表示名',
  });

  lastName = createField((label) => requiredStringField(label, 1, 128), 'lastName', {
    ja: '姓',
  });

  firstName = createField((label) => requiredStringField(label, 1, 128), 'firstName', {
    ja: '名',
  });

  email = createField((label) => newEmailField(label), 'email', {
    ja: 'メールアドレス',
  });

  password = createField((label) => newPasswordField(label), 'password', {
    ja: '現在のパスワード',
  });

  newPassword = createField((label) => newPasswordField(label), 'newPassword', {
    ja: '新しいパスワード',
  });

  confirmNewPassword = createField(
    () => h.string().min(1, formStrings.repeatPrompt(this.newPassword.label)),
    'confirmNewPassword',
    {
      ja: '新しいパスワード再入力',
    },
  );

  toProfileUpdateSchema() {
    return t.type({
      lastName: this.lastName.type,
      firstName: this.firstName.type,
      email: this.email.type,
    });
  }

  toSecurityUpdateSchema() {
    return t.type({
      password: this.password.type,
      newPassword: this.newPassword.type,
      confirmNewPassword: this.confirmNewPassword.type,
    });
  }
}
